var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwouser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3066 3.50054C13.7616 3.50054 14.9316 4.67804 14.9316 6.12554C14.9316 7.54304 13.8066 8.69804 12.4041 8.75054C12.3393 8.74304 12.2738 8.74304 12.2091 8.75054M13.7541 15.5005C14.2941 15.388 14.8041 15.1705 15.2241 14.848C16.3941 13.9705 16.3941 12.523 15.2241 11.6455C14.8116 11.3305 14.3091 11.1205 13.7766 11.0005M6.86906 8.65304C6.79406 8.64554 6.70406 8.64554 6.62156 8.65304C5.76072 8.62381 4.94504 8.26067 4.34728 7.64051C3.74953 7.02035 3.41662 6.19188 3.41906 5.33054C3.41906 3.49304 4.90406 2.00054 6.74906 2.00054C7.63124 1.98463 8.4836 2.31981 9.11865 2.93235C9.75369 3.54489 10.1194 4.38462 10.1353 5.26679C10.1512 6.14897 9.81604 7.00133 9.2035 7.63638C8.59096 8.27142 7.75124 8.63713 6.86906 8.65304ZM3.11906 11.4205C1.30406 12.6355 1.30406 14.6155 3.11906 15.823C5.18156 17.203 8.56406 17.203 10.6266 15.823C12.4416 14.608 12.4416 12.628 10.6266 11.4205C8.57156 10.048 5.18906 10.048 3.11906 11.4205V11.4205Z",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwouser);
export default __webpack_public_path__ + "static/media/twouser.66d6fd7fb2cc8982091323de5bbcedd7.svg";
export { ForwardRef as ReactComponent };